module.exports = __webpack_public_path__ + "fca71d1bb6251f63e79f09c75fa8f2da.MP3";